var icon = require('vue-svgicon')
icon.register({
  'ks-icon-close': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M106 30.46L97.54 22 64 55.54 30.46 22 22 30.46 55.54 64 22 97.54l8.46 8.46L64 72.46 97.54 106l8.46-8.46L72.46 64z"/>'
  }
})
